import * as React from 'react';
import {HeadFC, PageProps, graphql, navigate} from 'gatsby';
import Logo from 'design-system/src/Components/Logo/Logo.web';
import Button from 'design-system/src/Components/Button/Button';
import {useTranslation} from 'gatsby-plugin-react-i18next';

const pageStyles: React.CSSProperties = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #1a2233 0%, #232129 100%)',
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Inter, -apple-system, Roboto, sans-serif, serif',
  padding: 0,
};
const headingStyles: React.CSSProperties = {
  marginTop: 0,
  marginBottom: 24,
  fontSize: '3rem',
  fontWeight: 700,
  letterSpacing: 2,
  color: '#ff6a00',
  textShadow: '0 2px 16px #0008',
};
const paragraphStyles: React.CSSProperties = {
  marginBottom: 32,
  fontSize: '1.25rem',
  color: '#cfd8dc',
  textAlign: 'center' as React.CSSProperties['textAlign'],
  maxWidth: 420,
};
const codeStyles: React.CSSProperties = {
  color: '#ff6a00',
  padding: '4px 8px',
  backgroundColor: '#232129',
  fontSize: '1.1rem',
  borderRadius: 6,
  fontFamily: 'monospace',
  margin: '0 4px',
};
const logoStyles: React.CSSProperties = {
  marginBottom: 32,
  height: 48,
  width: 160,
  display: 'block',
};

const NotFoundPage: React.FC<PageProps> = () => {
  const {t} = useTranslation('ui');

  const title404 = t('404.title');
  const message404 = t('404.message');
  const goBackTitle = t('404.goBackBtnText');

  return (
    <main style={pageStyles}>
      <h1 style={headingStyles}>{title404}</h1>
      <p style={paragraphStyles}>
        {message404}
        <br />
        {process.env.NODE_ENV === 'development' ? (
          <>
            <br />
            <span style={{color: '#ffb347'}}>Astuce dev&nbsp;:</span> crée une
            page dans
            <code style={codeStyles}>src/pages/</code>.<br />
          </>
        ) : null}
      </p>
      <Button
        variant="contained"
        size="medium"
        title={goBackTitle}
        trackingData={{
          type: 'button',
          name: goBackTitle,
          section: '404',
          page: '404',
          blockType: '404-page',
          blockName: '404 Page',
        }}
        onPress={() => navigate('/')}
      />
    </main>
  );
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default NotFoundPage;

export const Head: HeadFC = () => <title>Trace+ | Not Found</title>;
